import styled from 'styled-components';
import { Item } from '../Global/ColorPicker';
import { SECONDARY_COLOR, SECONDARY_COLOR_5 } from '../../const/color';
import { FAMILY_FONT_CONTROL, FAMILY_FONT_PRIMARY } from '../../const/text';
import { OutlinedButton, PrimaryButton } from '../Global/Button';
import { device } from '../../const/device';
import { Toggle } from '../Global';

export const DisableOverlaySpec = styled.div<{disOverSpec:boolean, themeColor: string}>`
  display: ${ props => props.disOverSpec ? 'flex' : 'none'};
  position: absolute;
  background: ${props => props.themeColor == "black"? '#181818':'#fefefe'};
  width: 100%;
  height: 450px;
  opacity: .7;
`

export const DisableOverlayOther = styled.div<{disOverOther:boolean, themeColor: string}>`
  display: ${ props => props.disOverOther ? 'flex' : 'none'};
  position: absolute;
  background: ${props => props.themeColor == "black"? '#181818':'#fefefe'};
  width: 100%;
  height: 100%;
  opacity: .7; 
  z-index: 12000; 
`

export const TextColorItem = styled(Item)`
  width: 44px;
  height: 44px;
  margin: 0 0 0 25px;
  
  &:before {
    content: '';
    position: absolute;
    top: 0px;
    left: -3px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
  }

  @media (${device.mobileL}) {
    width: 32px;
    height: 32px;
    margin: 0 11px 0 0;
    &:before {
      top: -1px;
      left: -1px;
      width: 32px;
      height: 32px;
    }
  }
`;

export const TextColorInput = styled.input`
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
`;

export const InputLabel = styled.label`
  display: inline-block;
  font-family: ${FAMILY_FONT_CONTROL};
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
`;

export const InputWrapper = styled.div`
  //margin-top: 14px;
  margin-bottom: 32px;  
  display: flex;
  align-items: center;
  
  @media (${device.mobileL}) {
    flex-direction: row-reverse;
    margin-bottom: 0px;
  }
`;

export const TextScreenWrapper = styled.div`
  margin-left: 64px;
`;


export const SpecContainer = styled.div`
  display: flex;
  padding-top: 25px;
  margin-top: -4px;
  border-top: 1px solid ${SECONDARY_COLOR_5};
  justify-content: space-between;
  flex-wrap: wrap;
  @media (${device.tablet}) {
    border: none;
    padding-bottom:65px;
    display:grid;
    grid-template-columns:calc(50% - 16px) calc(50% - 16px);
    grid-gap:32px;

  }
  @media (${device.mobileL}) {
    padding-top: 0;
    margin-top: 0;
    padding-bottom: 16px;
    grid-template-columns:1fr;
    grid-gap: 16px;
  }
`;
export const SpecItem = styled.div`
  margin-bottom: 32px;
  @media (${device.tablet}) {
    margin-bottom: 0;
  }
  
  @media (${device.mobileL}) {
    display: flex;
    align-items: center;
    
    width: 100%;
    ${Toggle.Container} {
      margin-left: auto;
      flex: 0 0 80%;
      width: 100% !important;
    }
    ${Toggle.Item} {
      width: 100%;
    }
  }
`;

export const SpecItemSize = styled(SpecItem)`
  width:100%;
  display:grid;

  @media (${device.mobileL}) {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
  }
`;

export const AddCartItem = styled.button<{disable?:string, themeColor: string}>`
  width: 100%;
  margin: 10px 0;
  padding: 10px;
  display: flex;
  border: 0;
  color: #fff;
  justify-content: center;
  text-transform: uppercase;
  font-family: ${ FAMILY_FONT_PRIMARY } !important;
  cursor: ${ props => props.disabled ? 'none' : 'pointer'};
  background: ${ props => props.disable ? '#8d8d8d': '#000' };
  border: 1px solid ${props => props.themeColor == "black"?'#ffffff':SECONDARY_COLOR};
`;

export const Message = styled.div`
  display: flex;
  width: 100%;
  font-size: 12px;
  padding: 5px 0 20px 0;;
  justify-content: center;
  font-family: ${ FAMILY_FONT_CONTROL };
`;

export const SpecItemPrice = styled.div`
  width:100%;
  display:grid;
  margin-bottom: 12px;
  
  @media (${device.mobileL}) {
    grid-template-columns: 1fr;
  }
    
  @media (${device.tablet}) {
    margin-bottom: 0;
  }
  
  @media (${device.mobileL}) {
    ${Toggle.Container} {
      margin-left: auto;
      flex: 0 0 80%;
      width: 100% !important;
    }
    ${Toggle.Item} {
      width: 100%;
    }
  }
`;
export const SpecItemPriceTwoRows = styled(SpecItemPrice)`
    grid-template-columns: 1fr 25%;
`;
export const SpecItemText = styled.div<{ themeColor: string }>`
  font-family: ${FAMILY_FONT_CONTROL};
  font-size: 16px;
  color: ${props => props.themeColor == "black" ? '#ffffff' : SECONDARY_COLOR};
  margin-bottom: 9px;
  
  @media (${device.mobileL}) {
    margin-bottom: 0;
    margin-right: 15px;
    font-size: 14px;
    font-weight: bold;
    white-space:nowrap;
  }
`;
export const SpecItemTextSummary = styled.div<{ themeColor: string }>`
  font-size: 16px;
  color: ${props => props.themeColor == "black" ? '#ffffff' :SECONDARY_COLOR };
  margin-bottom: 9px;
  padding-bottom: 15px;
  text-transform: uppercase;
  border-bottom: 1px solid rgb(232, 232, 232);
  
  @media (${device.mobileL}) {
    margin-bottom: 0;
    margin-right: 15px;
    font-size: 14px;
    font-weight: bold;
    white-space:nowrap;
  }
`;
export const SpecItemTextTotalPrice = styled.div<{ themeColor: string }>`
  font-size: 16px;
  color: ${props => props.themeColor == "black" ? '#ffffff' : SECONDARY_COLOR};
  margin-bottom: 9px;
  padding-top: 15px;
  padding-bottom: 15px;
  text-transform: uppercase;
  border-top: 1px solid rgb(232, 232, 232);
  border-bottom: 1px solid rgb(232, 232, 232);
  
  @media (${device.mobileL}) {
    margin-bottom: 0;
    padding-right: 15px;
    font-size: 14px;
    font-weight: bold;
    white-space:nowrap;
  }
`;
export const SpecItemTextTotalPriceTo = styled(SpecItemTextTotalPrice)`
    text-align: end;
`;
export const SpecItemTextTotal = styled.div<{ themeColor: string }>`
  font-family: ${FAMILY_FONT_CONTROL};
  font-size: 16px;
  color: ${props => props.themeColor == "black" ? '#ffffff' : SECONDARY_COLOR};
  margin-bottom: 12px;
  
  @media (${device.mobileL}) {
    margin-bottom: 0;
    padding-top: 15px;
    padding-right: 15px;
    padding-bottom: 15px;
    font-size: 14px;
    font-weight: bold;
    white-space:nowrap;
  }
`;
export const SpecItemTextTotalPr = styled(SpecItemTextTotal)`
    text-align: end;
`;
export const Wrapper = styled.div`
  
  @media (${device.tablet}) {
    display: grid;
    grid-template-columns: calc(50% - 16px) calc(50% - 16px);
    grid-column-gap: 32px;
  }

  @media (${device.tabletS}) {
    grid-template-columns: 1fr;
    grid-gap:32px;
  }

  @media (${device.mobileL}) {
    grid-gap: 16px;
  }
`;
export const ControlItem = styled.div`

  @media (${device.mobileL}) {
    min-height: 48px;
    margin-bottom: 20px;
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  position: relative;
  bottom: 0;
  display: flex;

  @media (${device.mobileL}) {
   position:static;
  }
`;

export const SaveButton = styled(OutlinedButton)<{loading:string, themeColor: string}>`
  height: 48px;
  width: 50%;
  text-transform: uppercase;
  margin-right: 8px;

  opacity: ${props => props.loading === "true" ? "0.5" : "1"};
  pointer-events: ${props => props.loading === "true" ? "none" : "auto"};
  
  color: ${props => props.themeColor == "black"?'#ffffff':SECONDARY_COLOR};
  border: 1px solid ${props => props.themeColor == "black"?'#ffffff':SECONDARY_COLOR};
`

export const CheckoutButton = styled(PrimaryButton)<{loading:string}>`
  width: 50%;
  height: 48px;
  text-transform: uppercase;
  margin-left: 8px;
  
  opacity: ${props => props.loading === "true" ? "0.5" : "1"};
  pointer-events: ${props => props.loading === "true" ? "none" : "auto"};
`;

export const ButtonLinkCart = styled.div`
    width: 50%;
    height: 48px;
    margin-left: 8px;
    border-radius: 2px;
    text-align: center;
    color: #fff;
    padding-top: 14px;
    text-decoration: none;
    background-color: #10CBA5;
`;
